import * as Yup from 'yup'

export const PasswordSchema = Yup.object().shape({
  password: Yup.string().required('This field is required.')
});
